/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The DeleteStatusAndTransferJobs model module.
 * @module model/DeleteStatusAndTransferJobs
 * @version V1
 */
class DeleteStatusAndTransferJobs {
    /**
     * Constructs a new <code>DeleteStatusAndTransferJobs</code>.
     * @alias module:model/DeleteStatusAndTransferJobs
     * @param currentStatusID {Number} 
     * @param updateStatusID {Number} 
     */
    constructor(currentStatusID, updateStatusID) { 
        
        DeleteStatusAndTransferJobs.initialize(this, currentStatusID, updateStatusID);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, currentStatusID, updateStatusID) { 
        obj['currentStatusID'] = currentStatusID;
        obj['updateStatusID'] = updateStatusID;
    }

    /**
     * Constructs a <code>DeleteStatusAndTransferJobs</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/DeleteStatusAndTransferJobs} obj Optional instance to populate.
     * @return {module:model/DeleteStatusAndTransferJobs} The populated <code>DeleteStatusAndTransferJobs</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new DeleteStatusAndTransferJobs();

            if (data.hasOwnProperty('currentStatusID')) {
                obj['currentStatusID'] = ApiClient.convertToType(data['currentStatusID'], 'Number');
            }
            if (data.hasOwnProperty('updateStatusID')) {
                obj['updateStatusID'] = ApiClient.convertToType(data['updateStatusID'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>DeleteStatusAndTransferJobs</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>DeleteStatusAndTransferJobs</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of DeleteStatusAndTransferJobs.RequiredProperties) {
            if (!data.hasOwnProperty(property)) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }

        return true;
    }


}

DeleteStatusAndTransferJobs.RequiredProperties = ["currentStatusID", "updateStatusID"];

/**
 * @member {Number} currentStatusID
 */
DeleteStatusAndTransferJobs.prototype['currentStatusID'] = undefined;

/**
 * @member {Number} updateStatusID
 */
DeleteStatusAndTransferJobs.prototype['updateStatusID'] = undefined;






export default DeleteStatusAndTransferJobs;

